module.exports = __webpack_public_path__ + "img/feature_c03.efeb9cf3.svg";